import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';

export default class WithPart extends Route {
  @service site;
  @service router;

  model(parms) {
    this.site.setPartId(parms.partid.toUpperCase());
    this.router.transitionTo('index', { queryParams: this.mapQueryParams(parms) });
  }

  mapQueryParams(params) {
    let queryParams = {};
    if (params.doc) queryParams.doc = params.doc;
    return queryParams;
  }
}
